import { useEffect, useState } from "react";
import MyCalendar from "../../components/MyCalender";
import { ProgressHeader } from "../../components/ProgressHeader";
import { ProgressStats } from "../../components/ProgressStats";

//API
import { getProgress } from "../../components/funtionsBD/progress";
import { DateRange } from "../../components/DateRange";

export const Progress = () => {
  const [stats, setStats] = useState([]);
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  // get news

  const getProgressLocal = async () => {
    const stats = await getProgress();

    setStats(stats);
  };

  useEffect(() => {
    getProgressLocal();
  }, []);

  return (
    <>
      <div id="adminRoot">
        <ProgressHeader />
        <DateRange
          selectionRange={selectionRange}
          setSelectionRange={setSelectionRange}
        />
        <ProgressStats stats={stats} />
      </div>
    </>
  );
};
